import _typeof from "@babel/runtime/helpers/esm/typeof";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
export var LocalStorageKey;
(function (LocalStorageKey) {
  LocalStorageKey["KEY_PREFER_VERIFY_TYPE"] = "key_prefer_verify_type";
  LocalStorageKey["CONFIG_LOCALE"] = "LANGUAGE_DATA_TYPE";
})(LocalStorageKey || (LocalStorageKey = {}));
export var TVStorageKey;
(function (TVStorageKey) {
  TVStorageKey["interval"] = "tradingview.chart.lastUsedTimeBasedResolution";
})(TVStorageKey || (TVStorageKey = {}));
export var LocalStorageUtils = /*#__PURE__*/function () {
  function LocalStorageUtils() {
    _classCallCheck(this, LocalStorageUtils);
  }
  _createClass(LocalStorageUtils, null, [{
    key: "get",
    value: function get(key) {
      return window.localStorage.getItem(key);
    }
  }, {
    key: "set",
    value: function set(key, value) {
      window.localStorage.setItem(key, value);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      window.localStorage.removeItem(key);
    }
  }, {
    key: "getBoolean",
    value: function getBoolean(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (defaultValue) {
        return LocalStorageUtils.get(key) !== "false";
      } else {
        return LocalStorageUtils.get(key) === "true";
      }
    }
  }, {
    key: "setBoolean",
    value: function setBoolean(key, value) {
      LocalStorageUtils.set(key, value ? "true" : "false");
    }
  }, {
    key: "getObject",
    value: function getObject(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var data = this.get(key);
      if (!data) {
        return defaultValue;
      }
      try {
        return JSON.parse(data);
      } catch (e) {}
      return defaultValue;
    }
  }, {
    key: "setObject",
    value: function setObject(key, value) {
      if (typeof value !== "boolean" && (!value || _typeof(value) !== "object")) {
        this.remove(key);
        return;
      }
      this.set(key, JSON.stringify(value));
    }
  }]);
  return LocalStorageUtils;
}();